import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
var TransformerEfficiencyCalComponent = /** @class */ (function () {
    function TransformerEfficiencyCalComponent(globalService, router, snackBar) {
        this.globalService = globalService;
        this.router = router;
        this.snackBar = snackBar;
        this.resistanceMilliohm = 0.03;
        this.ironLossWatts = 1875;
        this.strayLossPercent = 7;
        this.readings = [];
        this.selectedReadingId = null;
        this.currentUserData = JSON.parse(localStorage.getItem('userData'));
        this.inputPowerKW = 0;
        this.outputPowerKW = 0;
        this.copperLossKW = 0;
        this.ironLossKW = 0;
        this.strayLossKW = 0;
        this.totalLossKW = 0;
        this.efficiencyPercent = 0;
        this.selectedTransformer_E = null;
        this.transformerList_E = [];
        this.filterresultData = [];
        this.isLoading = false;
        this.mainChartData = [];
        this.lossChartData = [];
        this.mainChart = {
            layout: {
                autosize: true,
                margin: { l: 25, r: 25, t: 10, b: 25 },
                xaxis: {
                    title: 'Time',
                    font: { size: 7 },
                    showgrid: true,
                    gridwidth: 1,
                    gridcolor: '#e5e7eb',
                    automargin: true
                },
                yaxis: {
                    title: 'Power (kW)',
                    font: { size: 7 },
                    showgrid: true,
                    gridwidth: 1,
                    gridcolor: '#e5e7eb',
                    automargin: true
                },
                yaxis2: {
                    title: 'Efficiency (%)',
                    overlaying: 'y',
                    side: 'right',
                    font: { size: 7 },
                    showgrid: false,
                    automargin: true
                },
                legend: {
                    x: 0,
                    y: 1,
                    bgcolor: 'rgba(255,255,255,0.9)',
                    bordercolor: 'rgba(0,0,0,0.2)',
                    borderwidth: 1,
                    font: { size: 7 },
                    orientation: 'h'
                },
                plot_bgcolor: 'rgba(0,0,0,0)',
                paper_bgcolor: 'rgba(0,0,0,0)',
                height: undefined
            },
            config: {
                displayModeBar: true,
                modeBarButtonsToRemove: ['zoom2d', 'pan2d', 'select2d', 'lasso2d', 'toggleSpikelines'],
                displaylogo: false,
                responsive: true,
                toImageButtonOptions: {
                    format: 'png',
                    filename: 'transformer_efficiency_chart',
                    height: '100%',
                    width: 700,
                    scale: 1
                }
            }
        };
        this.lossChart = {
            layout: {
                autosize: true,
                margin: { l: 25, r: 25, t: 20, b: 35 },
                xaxis: {
                    title: { text: 'Time', standoff: 10 },
                    tickfont: { size: 10 },
                    showgrid: true,
                    gridwidth: 1,
                    gridcolor: '#e5e7eb',
                    automargin: true
                },
                yaxis: {
                    title: { text: 'Loss (kW)', standoff: 10 },
                    tickfont: { size: 10 },
                    showgrid: true,
                    gridwidth: 1,
                    gridcolor: '#e5e7eb',
                    automargin: true
                },
                legend: {
                    x: 0,
                    y: 1,
                    bgcolor: 'rgba(255,255,255,0.9)',
                    bordercolor: 'rgba(0,0,0,0.2)',
                    borderwidth: 1,
                    font: { size: 9 },
                    orientation: 'h'
                },
                plot_bgcolor: 'rgba(0,0,0,0)',
                paper_bgcolor: 'rgba(0,0,0,0)'
            },
            config: {
                responsive: true,
                displayModeBar: true,
                displaylogo: false,
                modeBarButtonsToRemove: [
                    'zoom2d',
                    'pan2d',
                    'select2d',
                    'lasso2d',
                    'toggleSpikelines'
                ],
                toImageButtonOptions: {
                    format: 'png',
                    filename: 'transformer_loss_chart',
                    scale: 1
                }
            }
        };
    }
    TransformerEfficiencyCalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.selectedReadingId = this.readings.length > 0 ? this.readings[0].id : null;
        this.recalculate();
        this.gettransformerId();
        window.addEventListener('resize', function () {
            setTimeout(function () {
                _this.updateCharts();
            }, 100);
        });
    };
    TransformerEfficiencyCalComponent.prototype.onTransformerChange = function (selected) {
        var _this = this;
        this.selectedTransformer_E = selected;
        if (selected && selected.transformerid) {
            this.isLoading = true;
            var deviceData = this.filterresultData.find(function (item) { return item.transformerid === selected.transformerid; });
            this.globalService.getTransformerReading(selected.transformerid).subscribe({
                next: function (res) {
                    console.log('Transformer reading response:', res);
                    if (res.exists) {
                        _this.resistanceMilliohm = res.data.resistance;
                        _this.ironLossWatts = res.data.ironLossWatts;
                        _this.strayLossPercent = res.data.strayLoss;
                    }
                    _this.isLoading = false;
                },
                error: function (err) {
                    console.error('Error fetching transformer reading:', err);
                    _this.isLoading = false;
                }
            });
            if (deviceData && deviceData.deviceId) {
                this.getdata(deviceData.deviceId);
            }
            else {
                console.warn('No device found for this transformer.');
                this.isLoading = false;
            }
        }
    };
    TransformerEfficiencyCalComponent.prototype.getdata = function (id) {
        var _this = this;
        this.globalService.getEfficiencyData(id).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                console.log("efficiency data", response);
                this.loadFromJson(response);
                this.recalculate();
                this.isLoading = false;
                setTimeout(function () {
                    _this.updateCharts();
                }, 100);
                return [2 /*return*/];
            });
        }); }, function (error) {
            console.error("Error loading efficiency data:", error);
            _this.isLoading = false;
        });
    };
    TransformerEfficiencyCalComponent.prototype.gettransformerId = function () {
        var _this = this;
        var payloadtogetTransformer = {
            "countryid": null,
            "stateid": null,
            "cityid": null,
            "zoneid": null,
            "locationid": null,
            "transformerid": null,
        };
        this.globalService.getfilteredTransformers(JSON.stringify(payloadtogetTransformer), localStorage.getItem('userData')).subscribe(function (response) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.filterresultData = response.result;
                console.log("adsddsdsd", this.currentUserData);
                if (this.currentUserData.roleid != 1) {
                    this.filterresultData = this.filterresultData.filter(function (item) { return item.amc_status == "Active"; });
                    if (this.filterresultData.length == 0) {
                        this.router.navigate(['/dashboard']);
                    }
                }
                this.selectedTransformer_E = this.filterresultData[0];
                this.transformerList_E = this.filterresultData.map(function (a) {
                    a.transformerDetail = a.transformerid + "[" + a.sitename + "]";
                    return a;
                });
                this.onTransformerChange(this.selectedTransformer_E);
                return [2 /*return*/];
            });
        }); });
    };
    Object.defineProperty(TransformerEfficiencyCalComponent.prototype, "selectedReading", {
        get: function () {
            var _this = this;
            var found = this.readings.find(function (r) { return r.id === _this.selectedReadingId; });
            return found || null;
        },
        enumerable: true,
        configurable: true
    });
    TransformerEfficiencyCalComponent.prototype.getReversedReadings = function () {
        return this.readings.slice().reverse();
    };
    TransformerEfficiencyCalComponent.prototype.selectReading = function (id) {
        this.selectedReadingId = id;
        this.recalculate();
    };
    TransformerEfficiencyCalComponent.prototype.onInputsChanged = function () {
        var _this = this;
        this.recalculate();
        setTimeout(function () {
            _this.updateCharts();
        }, 100);
    };
    TransformerEfficiencyCalComponent.prototype.loadFromJson = function (rows) {
        console.log("loading from json", rows);
        this.readings = [];
        for (var i = 0; i < rows.length; i++) {
            var row = rows[i];
            var parseNum = function (v) {
                if (v === null || v === undefined)
                    return 0;
                var s = String(v).replace(/'/g, '').trim();
                var n = parseFloat(s);
                return isNaN(n) ? 0 : n;
            };
            var parseDate = function (v) {
                var s = String(v).replace(/'/g, '').trim();
                var d = new Date(s);
                return isNaN(d.getTime()) ? new Date() : d;
            };
            var vRY = parseNum(row.RY_Voltage);
            var vYB = parseNum(row.YB_Voltage);
            var vBR = parseNum(row.BR_Voltage);
            var iL1 = parseNum(row.L1);
            var iL2 = parseNum(row.L2);
            var iL3 = parseNum(row.L3);
            var pf = Math.abs(parseNum(row.Avg_Power_Factor));
            var ts = parseDate(row.Date);
            var vLineAvg = (vRY + vYB + vBR) / 3;
            var iAvg = (iL1 + iL2 + iL3) / 3;
            var lf = Number((iAvg / row.ratedLoad) * 100).toFixed(2);
            this.readings.push({
                id: 'J' + (i + 1),
                label: 'Reading ' + (i + 1),
                timestamp: ts,
                vRY: vRY, vYB: vYB, vBR: vBR,
                iL1: iL1, iL2: iL2, iL3: iL3,
                pf: pf,
                vLineAvg: vLineAvg,
                iAvg: iAvg,
                lf: lf
            });
        }
    };
    TransformerEfficiencyCalComponent.prototype.computeResultsFromMeasured = function (vLineAvg, iAvg, pf) {
        var outputKW = Math.sqrt(3) * vLineAvg * iAvg * pf / 1000;
        var rOhmPerPhase = this.resistanceMilliohm / 1000;
        var copperKW = (3 * iAvg * iAvg * rOhmPerPhase);
        var ironKW = Math.max(this.ironLossWatts, 0) / 1000;
        var totalKW = copperKW + ironKW;
        var strayKW = Math.max(this.strayLossPercent, 0) * totalKW / 100;
        var inputKW = outputKW + totalKW + strayKW;
        var eff = inputKW > 0 ? (outputKW / inputKW) * 100 : 0;
        return {
            outputKW: outputKW,
            copperKW: copperKW,
            ironKW: ironKW,
            strayKW: strayKW,
            totalKW: totalKW,
            inputKW: inputKW,
            eff: eff
        };
    };
    TransformerEfficiencyCalComponent.prototype.recalculate = function () {
        for (var i = 0; i < this.readings.length; i++) {
            var r = this.readings[i];
            var v = r.vLineAvg || 0;
            var ia = r.iAvg || 0;
            var pf = (r.pf === undefined || r.pf === null) ? 0 : r.pf;
            var rr = this.computeResultsFromMeasured(v, ia, pf);
            r.outputPowerKW = rr.outputKW;
            r.efficiencyPercent = rr.eff;
            r.copperLossKW = rr.copperKW;
            r.strayLossKW = rr.strayKW;
            r.totalLossKW = rr.totalKW;
            r.finalTotalLossKW = r.totalLossKW + r.strayLossKW;
        }
        var sr = this.selectedReading;
        if (!sr) {
            this.resetResults();
            return;
        }
        var res = this.computeResultsFromMeasured(sr.vLineAvg || 0, sr.iAvg || 0, sr.pf || 0);
        this.outputPowerKW = res.outputKW;
        this.copperLossKW = res.copperKW;
        this.ironLossKW = res.ironKW;
        this.strayLossKW = res.strayKW;
        this.totalLossKW = res.totalKW;
        this.inputPowerKW = res.inputKW;
        this.efficiencyPercent = res.eff;
        this.updateCharts();
    };
    TransformerEfficiencyCalComponent.prototype.updateCharts = function () {
        this.createMainChart();
        this.createLossChart();
    };
    TransformerEfficiencyCalComponent.prototype.createMainChart = function () {
        if (!this.readings || this.readings.length === 0)
            return;
        var time = this.readings.map(function (r) { return r.timestamp; });
        var outputPower = this.readings.map(function (r) { return r.outputPowerKW || 0; });
        var efficiency = this.readings.map(function (r) { return r.efficiencyPercent || 0; });
        this.mainChartData = [
            {
                x: time,
                y: outputPower,
                type: 'scatter',
                mode: 'lines+markers',
                name: 'Output (kW)',
                line: { color: '#3b82f6', width: 3 },
                marker: { size: 6 }
            },
            {
                x: time,
                y: efficiency,
                type: 'scatter',
                mode: 'lines+markers',
                name: 'Efficiency (%)',
                yaxis: 'y2',
                line: { color: '#0ea5e9', width: 3, dash: 'dash' },
                marker: { size: 6 }
            }
        ];
    };
    TransformerEfficiencyCalComponent.prototype.createLossChart = function () {
        if (!this.readings || this.readings.length === 0)
            return;
        var time = this.readings.map(function (r) { return r.timestamp; });
        var copperLoss = this.readings.map(function (r) { return r.copperLossKW || 0; });
        var strayLoss = this.readings.map(function (r) { return r.strayLossKW || 0; });
        var totalLoss = this.readings.map(function (r) { return r.totalLossKW || 0; });
        var finalTotalLoss = this.readings.map(function (r) { return r.finalTotalLossKW || 0; });
        this.lossChartData = [
            {
                x: time,
                y: copperLoss,
                type: 'scatter',
                mode: 'lines+markers',
                name: 'Copper (kW)',
                line: { color: '#ef4444', width: 3 },
                marker: { size: 6 }
            },
            {
                x: time,
                y: strayLoss,
                type: 'scatter',
                mode: 'lines+markers',
                name: 'Stray (kW)',
                line: { color: '#10b981', width: 3 },
                marker: { size: 6 }
            },
            {
                x: time,
                y: totalLoss,
                type: 'scatter',
                mode: 'lines+markers',
                name: 'Total Loss (kW)',
                line: { color: '#f59e0b', width: 3 },
                marker: { size: 6 }
            },
            {
                x: time,
                y: finalTotalLoss,
                type: 'scatter',
                mode: 'lines+markers',
                name: 'Final Total Loss (kW)',
                line: { color: '#8b5cf6', width: 3 },
                marker: { size: 6 }
            }
        ];
    };
    TransformerEfficiencyCalComponent.prototype.resetResults = function () {
        this.inputPowerKW = 0;
        this.outputPowerKW = 0;
        this.copperLossKW = 0;
        this.ironLossKW = 0;
        this.strayLossKW = 0;
        this.totalLossKW = 0;
        this.efficiencyPercent = 0;
    };
    TransformerEfficiencyCalComponent.prototype.formatTime = function (d) {
        var hh = d.getHours().toString().padStart(2, '0');
        var mm = d.getMinutes().toString().padStart(2, '0');
        return hh + ':' + mm;
    };
    TransformerEfficiencyCalComponent.prototype.saveReadings = function (transformerid, resistance, ironLossWatts, strayLoss) {
        var _this = this;
        var payload = {
            transformerid: transformerid,
            resistance: resistance,
            ironLossWatts: ironLossWatts,
            strayLoss: strayLoss
        };
        console.log('Saving readings:', payload);
        // Call the API via service
        this.globalService.saveTransformerReadings(payload).subscribe({
            next: function (res) {
                console.log('API response:', res);
                _this.snackBar.open(res && res.message ? res.message : 'Saved successfully', 'OK', {
                    duration: 2500,
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['snack-success']
                });
            },
            error: function (err) {
                console.error('Error saving readings:', err);
                _this.snackBar.open('Error saving readings', 'Dismiss', {
                    duration: 3000,
                    horizontalPosition: 'right',
                    verticalPosition: 'top',
                    panelClass: ['snack-error']
                });
            }
        });
    };
    TransformerEfficiencyCalComponent.prototype.downloadReport = function () {
        var e_1, _a;
        try {
            var lines = [];
            var transformerName = (this.selectedTransformer_E && (this.selectedTransformer_E.transformerDetail || this.selectedTransformer_E.transformerid)) || 'Transformer';
            lines.push('Transformer,Resistance (mOhm),Iron Loss (W),Stray Loss (%),Generated At');
            lines.push([
                "\"" + transformerName + "\"",
                this.resistanceMilliohm,
                this.ironLossWatts,
                this.strayLossPercent,
                new Date().toISOString()
            ].join(','));
            lines.push('');
            lines.push('Time,Copper (kW),Stray (kW),Total Loss (kW),Final Loss (kW),Output (kW),Efficiency (%)');
            var rows = this.getReversedReadings();
            try {
                for (var rows_1 = tslib_1.__values(rows), rows_1_1 = rows_1.next(); !rows_1_1.done; rows_1_1 = rows_1.next()) {
                    var r = rows_1_1.value;
                    var timeStr = r.timestamp ? this.formatTime(new Date(r.timestamp)) : '';
                    var row = [
                        timeStr,
                        ((r.copperLossKW != null ? r.copperLossKW : 0).toFixed(1)),
                        ((r.strayLossKW != null ? r.strayLossKW : 0).toFixed(1)),
                        ((r.totalLossKW != null ? r.totalLossKW : 0).toFixed(1)),
                        ((r.finalTotalLossKW != null ? r.finalTotalLossKW : 0).toFixed(1)),
                        ((r.outputPowerKW != null ? r.outputPowerKW : 0).toFixed(0)),
                        ((r.efficiencyPercent != null ? r.efficiencyPercent : 0).toFixed(1))
                    ].join(',');
                    lines.push(row);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (rows_1_1 && !rows_1_1.done && (_a = rows_1.return)) _a.call(rows_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var csvContent = lines.join('\r\n');
            var blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            var url = URL.createObjectURL(blob);
            var fileName = "transformer_report_" + new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-') + ".csv";
            var link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        }
        catch (err) {
            console.error('Failed to generate report:', err);
            this.snackBar.open('Failed to download report', 'Dismiss', {
                duration: 3000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['snack-error']
            });
        }
    };
    return TransformerEfficiencyCalComponent;
}());
export { TransformerEfficiencyCalComponent };
